import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'mixins-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>♽ Mixins</h1>
            <p class='section-text' tabindex='0'>
                In this section we will talk about <b>mixins</b> and how you can use them
                to save time, write less code, and share functionality between components.
            </p>
            <p class='section-text' tabindex='0'>
                While it may sound like a complicated topic for those not familiar with them,
                mixins are actually one of the simplest concepts in modern web development.
                A mixin is really just an object that you will add to your components, and
                when that object is added all of its properties will be added as well. This
                means that we can write similar Mosaic options in one object and then include
                them as a mixin to other components so that we only have to write complicated
                logic once and reuse it elsewhere!
            </p>
            <p class='section-text' tabindex='0'>
                Each component comes with a <b>mixins</b> property as part of its initialization
                options. This property is set to an array of objects, where each object has the
                same structure as the standard Mosaic options. Let's dive right in to an example
                so you can see exactly how it works.
            </p>
            <iframe style='margin-bottom:10px;' width="100%" height="300" src="//jsfiddle.net/authman2/3rn4hbzu/10/embedded/js,html,result/" allowfullscreen="allowfullscreen" allowpaymentrequest frameborder="0"></iframe>
            <p class='section-text' tabindex='0'>
                As you can see in this example, we separate the complicated logic of keeping a
                "count" variable, updating it every second, and removing the timer when the
                component is destroyed in a "mixin." Then we can create two separate components
                that use the same mixin, but still act independently. You can include as many
                mixins as you want, but just know that they will be applied (and hence, overriden
                if necessary) in order of the array. So, the last mixin in your array will take
                priority over the first one if it ends up running into naming conflicts.
            </p>
            <br>
            
            <p class='section-text' tabindex='0' style='text-align:center;'>
                Now that we've looked at mixins, let's move on to the Shadow DOM and all its uses
                in Mosaic and beyond.
            </p>
            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/view')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    View Function
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/shadowdom')}'>
                    Shadow DOM
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});